import React from 'react'
import AjaxLoader from '../../assets/img/ajax-loader.gif'

export const SpinnerLoader = () => {
    return (
        <div
            id="spinnerLoader"
            style={{
                display: 'none',
                marginRight: 'auto',
                marginLeft: 'auto',
                position: 'absolute',
                top: '50%',
                left: '50%',
                zIndex: 1000,
            }}
        >
            <Spinner />
        </div>
    )
}

export const Spinner = () => {
    return <img src={AjaxLoader} className="span3" alt="Loading..." />
}
